export const toUSD = (cents: number) => {
  return `${(cents / 100).toFixed(2)} USD`
}
